import styled from 'styled-components'
import { Button } from 'views/components/UI/Buttons'

export const Title = styled.h2`
  margin: 0;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 800;
  line-height: 1.2;
`

export const WrapperButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 44px 0 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    margin-top: 28px;
  }
`

export const P = styled.p`
  color: #e44646;
`
export const CreatePlatformAdminButton = styled(Button)``

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  margin: 0;
`
